import React, { Component } from "react";
import { parse } from "qs";
import { connect } from "dva";

import Container from "@/components/Container";
import TreeList from "../../components/TreeList";
import TargetTable from "./TargetTable";

import styles from "./index.less";

@connect(({ evaluation, tree }) => ({
  selectTreeNodeKey: tree.selectTreeNodeKey,
  currentselectTreeNodeIndexId: tree.currentselectTreeNodeIndexId,
  index: evaluation.index,
  self: evaluation.self,
  target: evaluation.target,
  isUpdate: evaluation.isUpdate,
  isDetail: evaluation.isDetail
}))
class EvaluationTree extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    this.state = {
      currentProjectId,
      selectEvaluateType: 1, // 指标类型 1-分组 0-详情
      remember: false,
      showTree: false
    };
  }

  componentDidMount() {
    this.getTreeList();
    this.init();
  }

  // componentWillUnmount() {
  //   const { dispatch } = this.props;
  //   const { remember } = this.state;
  //   if(!remember) {
  //     dispatch({
  //       type: 'tree/reset'
  //     });
  //   }
  // }

  init = () => {
    const { currentselectTreeNodeIndexId } = this.props;
    if (currentselectTreeNodeIndexId) {
      this.setState({
        selectEvaluateType: 2,
        indexId: currentselectTreeNodeIndexId
      });
    }
  };

  saveState = payload => {
    const { dispatch } = this.props;
    dispatch({
      type: "evaluation/save",
      payload
    });
  };

  getTreeList = id => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "tree/fetchEvaluationTargetTree",
      payload: {
        projectId: id || currentProjectId
      },
      callback: () => {
        this.setState({
          showTree: true
        });
      }
    });
  };

  handleChangeSelect = ({ type, code }) => {
    this.setState({
      selectEvaluateType: type,
      indexId: code
    });
  };

  renderRightSide = () => {
    const { selectEvaluateType, currentProjectId, indexId } = this.state;
    const { match } = this.props;
    const { path } = match;
    const targetProps = {
      projectId: currentProjectId,
      normIndex: indexId,
      onRemember: (remember, callback) =>
        this.setState({ remember }, () => callback())
    };

    if (selectEvaluateType === 2) {
      return (
        <div className="right-side">
          <div className="rightSideContainer">
            <TargetTable {...targetProps} nowPath={path} />
          </div>
        </div>
      );
    }
    return null;
  };

  render() {
    const { indexId, showTree } = this.state;

    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true,
      defaultPadding: true
    };

    return (
      <Container {...containerProps}>
        <div className={styles.tree}>
          <div className="container">
            <div className="norm-wrap">
              <div className="left-side">
                <div className="leftSideContainer">
                  {showTree && (
                    <TreeList
                      indexId={indexId}
                      onSelect={this.handleChangeSelect}
                      expandAllTree
                    />
                  )}
                </div>
              </div>
              {this.renderRightSide()}
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default EvaluationTree;
